import { Box, Heading } from '@chakra-ui/react'
import { useTranslation } from 'react-i18next';
import Card from 'shared/components/horizon-ui/card/Card';
import InfiniteTable from 'shared/components/table/InfiniteTable';
import useGetColors from 'shared/hooks/useGetColors';
import PageTitle from '../admin/PageTitle';
import { useGetColumns, useGetFilterFields, useGetGetBreadcrumbs } from './constants';
import { ChannelsT } from '../../api/types/channels';
import { useGetChannels, useActivateOneChannel, useDeactivateOneChannel, useDeleteChannel } from '../../api/requests/channels';
import { TableNameE } from 'shared/api/types/common';

const Index = () => {
  const { t } = useTranslation();
  const { blue800 } = useGetColors();
  const { mutate: activateMutation } = useActivateOneChannel();
  const { mutate: deactivateMutation } = useDeactivateOneChannel();
  const { mutate: deleteMutation } = useDeleteChannel();
  const handleActivate = (id: string) => activateMutation({ id });
  const handleDeactivate = (id: string) => deactivateMutation({ id });
  const handleDelete = (id: string) => deleteMutation({ id });
  const columns = useGetColumns({
    handleActivate,
    handleDeactivate,
    handleDelete,
  });
  const breadcrumbs = useGetGetBreadcrumbs();
  const filterFields = useGetFilterFields();

  return (
    <Box>
      <PageTitle title={t('channels.channels')} breadcrumbs={breadcrumbs} />
      <Card mb="20px" borderRadius="20px" px="30px">
        <Heading size="md" marginBottom={5} color={blue800}>
          {t('channels.channelsTable')}
        </Heading>
        <InfiniteTable<ChannelsT>
          query={useGetChannels}
          columns={columns}
          filterFields={filterFields}
          tableName={TableNameE.CHANNELS}
        />
      </Card>
    </Box>
  );
};

export default Index;
